export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant04-mobile-de.72954b55.png";